<template>
  <div class="navheader">
      <!-- Navbar -->
      <b-navbar toggleable="lg" type="dark">
        <!-- Logo -->
        <router-link to="/home"><b-navbar-brand> <cq-logo></cq-logo> </b-navbar-brand></router-link>

        <b-navbar-toggle v-b-toggle.collapse-1 target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="collapse-1" is-nav @click="isHidden=true">
          <!-- Left aligned nav items -->
          <b-navbar-nav  class="mlauto">
            <b-nav-form>
              <div class="d-lg-none d-sm-block" id="close" v-b-toggle.collapse-1>
                <i class="fa fa-times" aria-hidden="true"></i>
              </div>
              <cq-menubarleft> </cq-menubarleft>
            </b-nav-form>
            <!-- <div class="d-lg-none d-sm-block">
              <router-link to="/calendar"><cq-menubarright menubarbtn="CALENDAR OF EVENTS" last="true" curvedfront="true" rightside="true"></cq-menubarright></router-link>
            </div> -->
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <!-- <b-navbar-nav class="ml-auto d-none d-lg-block d-xl-block">
            <router-link to="/calendar"><cq-menubarright menubarbtn="CALENDAR OF EVENTS" last="true" curvedfront="true" rightside="true"></cq-menubarright></router-link>
          </b-navbar-nav> -->
        </b-collapse>
      </b-navbar>
    <!-- End Navbar -->
  </div>
</template>

<script>
import CQLogo from './CQLogo.vue'
import CQMenubarLeft from './CQMenubarLeft.vue'
// import CQMenubarRight from './CQMenubarRight.vue'

export default {
    components: {
        'cq-logo' : CQLogo,
        'cq-menubarleft' : CQMenubarLeft,
        // 'cq-menubarright' : CQMenubarRight,
    },
    data() {
        return{
            isHidden: false
        }
    }
}
</script>

<style scoped>
/* Navheader */
.navheader {
  position: sticky;
  top: 0;
  z-index: 9999;
  background-color: #fff;
}

/* Logo */
.navheader >>> .cq-logo img {
  width: 250px !important;
  margin-left: 30px !important;
}
/* End Logo */

@media only screen and (max-width: 992px){
    /* Menubar */
  .navheader >>> .cq-logo img {
    width: 150px !important;
    margin-left: 0 !important;
  }

  /* .navheader >>> .navbar-toggler-icon{
    background-color: var(--primary-color) !important;
    transform: translate(14px, -6px) !important;
    border-radius: 15%;
  } */

  .navheader >>> .navbar-toggler, .navheader >>> .span{
    background-image: url(../../assets/image/common/togglerbtn.png) !important;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .navheader >>> .navbar-toggler-icon{
    background-image: none;
  }
  
  .navheader >>> .navbar-collapse{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    display: flex;
    height: 100vh;
    z-index: 1000;
    align-items: center;
    justify-content: center;
    opacity: 0.9;
    font-size: 18px;
    background-color: rgb(108, 117, 125);
    text-align: center;
  }

  .navheader >>> #close{
    position: absolute;
    color: white;
    top: 26px;
    right: 8px;
    background-color: black;
    padding: 10px 15px;
    cursor: pointer;
  }

  .navheader >>> .cq-menubarbtn .btn{
    font-size: 22px;
  }
  /* End Menubar */

}

@media only screen and (min-width: 992px){
  .navheader{
    display: flex;
    justify-content: center;
  }

  .mlauto{
    margin-left: auto;
  }
}
</style>